import { createContext, useContext } from 'react';
import type { WebSocketContextValue } from '../modules/call/types/call.types';

export const WebSocketContext =
  createContext<WebSocketContextValue | null>(null);

export function useWebSocket(): WebSocketContextValue {
  const ctx = useContext(WebSocketContext);
  if (!ctx) {
    throw new Error(
      'useWebSocket must be used within <WebSocketProvider>'
    );
  }
  return ctx;
}
